import { VisuallyHidden } from "@99tech/ui";
import { Box, Stack } from "@mui/material";
import React, { useCallback, useContext } from "react";
import {
  BankAndApp,
  Bg,
  BtnLogin,
  BtnRegister,
  Chars,
  CharsHead,
  Logo,
  Providers,
  TextBottom,
  TextHead,
} from "src/assets";
import { AppContext } from "src/main/constants";
import { createStyles, isMobile } from "src/main/utils";

interface LandingPageProps extends React.PropsWithChildren {}

const LandingPage: React.FC<LandingPageProps> = (props) => {
  const { urls } = useContext(AppContext);
  const { loginUrl, registerUrl } = urls ?? {};

  const handleClick = useCallback(
    (type: "login" | "register") => (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      if (type === "login") {
        window.open(loginUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      } else {
        window.open(registerUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      }
    },
    [loginUrl, registerUrl],
  );

  return (
    <Box sx={styles.root}>
      <VisuallyHidden as="h1">WOWCAIRO</VisuallyHidden>
      <Stack
        direction="column"
        alignItems="center"
        width="100%"
        textAlign="center"
      >
        <img
          alt="chars-head"
          src={CharsHead}
          style={{ width: 360, marginTop: "-16px" }}
        />

        <img
          alt="logo"
          src={Logo}
          style={{ width: 272, marginTop: "-78px" }}
        />

        <img
          alt="text-head"
          src={TextHead}
          style={{ width: 330, marginTop: "-4px" }}
        />

        <Stack
          direction="row"
          justifyContent="center"
          zIndex={10}
          gap={1.5}
        >
          <a
            href={loginUrl}
            onClick={handleClick("login")}
            target="_blank"
            rel="noreferrer"
          >
            <img
              alt="btn-login"
              src={BtnLogin}
              style={{ height: 46 }}
            />
          </a>
          <a
            href={registerUrl}
            onClick={handleClick("register")}
            target="_blank"
            rel="noreferrer"
          >
            <img
              alt="btn-register"
              src={BtnRegister}
              style={{ height: 46 }}
            />
          </a>
        </Stack>

        <img
          alt="chars"
          src={Chars}
          style={{ width: 360, marginTop: "-16px" }}
        />

        <img
          alt="text-bottom"
          src={TextBottom}
          style={{ width: 340 }}
        />

        <img
          alt="providers"
          src={Providers}
          style={{ width: 360 }}
        />

        <img
          alt="logo"
          src={Logo}
          style={{ width: 156, marginTop: "-4px" }}
        />

        <img
          alt="bank-and-app"
          src={BankAndApp}
          style={{ width: 160, marginTop: "-12px" }}
        />
      </Stack>
    </Box>
  );
};

const styles = createStyles({
  root: {
    backgroundImage: `url(${Bg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center 0px",
    backgroundColor: "black",

    p: "16px",
    mx: "-16px",

    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    gap: "0px",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    overflowX: "hidden",
    color: "#fff",
  },
});

export default LandingPage;
